module.exports = __webpack_public_path__ + "static/triangle_background2-6eded4a7ad80c007fb65f02c828e5dd0.jpg";